import { Box } from '@chakra-ui/react';
import { setupI18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { useMemo } from 'react';

import { messages as enMessages } from '#features/i18n/locales/en/messages.po';
import { messages as ruMessages } from '#features/i18n/locales/ru/messages.po';
import { LandingFooter } from '#features/landing/components/Landing/Footer';

/** Render the actual full footer regardless of account state; no external links are followed. */
export const Route = createFileRoute('/{-$locale}/_layout/preview/footer-socials')({
  ssr: false,
  staticData: { rendersOwnFooter: true },
  beforeLoad: () => {
    if (!import.meta.env.DEV) throw notFound();
  },
  validateSearch: (search: Record<string, unknown>) => ({
    lang: search.lang === 'en' ? ('en' as const) : ('ru' as const),
  }),
  head: () => ({ meta: [{ name: 'robots', content: 'noindex, nofollow' }] }),
  component: FooterPreview,
});

function FooterPreview() {
  const { lang } = Route.useSearch();
  const i18n = useMemo(
    () => setupI18n({ locale: lang, messages: { en: enMessages, ru: ruMessages } }),
    [lang]
  );
  return (
    <I18nProvider i18n={i18n}>
      <Box w="100%" maxW="1100px" mx="auto" px={{ base: 4, md: 6 }}>
        <LandingFooter />
      </Box>
    </I18nProvider>
  );
}
